import { Component, HostListener, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { LoginService } from '../../services/login.service';
import { RouterLink } from '@angular/router';
import { Store } from '@ngrx/store';
import { selectClient } from '../../store/client/client.selects';
import { ClientModel } from '../../models/client.model';
import { Observable } from 'rxjs';
import { AsyncPipe, NgClass } from '@angular/common';

@Component({
    selector: 'app-navbar',
    imports: [TranslateModule, RouterLink, AsyncPipe, NgClass],
    templateUrl: './navbar.component.html',
    styleUrl: './navbar.component.scss'
})
export class NavbarComponent {
    public loginService: LoginService = inject(LoginService);
    public store: Store = inject(Store);
    public isScrolled: boolean = false;
    
    client$: Observable<ClientModel | null> = this.store.select(selectClient);

    @HostListener('window:scroll')
    onScroll() {
        const scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
        this.isScrolled = scrollPosition > 50; 
    }
}
